import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import ContactForm from '../components/contactform'
import { InfoContainer3, InfoWrapper, TextImageSection, TextBlock, ImageBlock } from '../components/InfoSection/InfoElements'
import { SocialIcons2, SocialIconLink2 } from '../components/Footer/FooterElements'
import { FaFacebook, FaInstagram, FaYoutube, FaTiktok } from 'react-icons/fa'


import img from '../images/nowe/dowolnie(6).png';
import img2 from '../images/nowe/dowolnie(4).png';


const Kontakt = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

  return (
    <>
    <Navbar toggle={toggle} />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <InfoContainer3 lightBg='true'>
      <InfoWrapper>
          <TextImageSection>
            <TextBlock>
              <h2>Kontakt</h2>
              <p>
                W chwilach przejścia warto pamiętać, że nie musisz wszystkiego organizować samodzielnie. Możesz zrobić to z większym spokojem i poczuciem bezpieczeństwa. Skontaktuj się ze mną możliwie szybko – wiele zadań, które próbujesz podjąć samodzielnie, wchodzi w zakres moich pakietów wsparcia. Dzięki temu mogę Cię realnie odciążyć.
              </p>
            </TextBlock>
          <ImageBlock>
            <img src={img} alt="Atenida" />
          </ImageBlock>
          </TextImageSection>
            <br></br><br></br>
            <center><h1>Wyślij wiadomość</h1></center>
            <TextImageSection>
              <ImageBlock>
                <img src={img2} alt="Atenida" />
              </ImageBlock>
              <TextBlock>
                <ContactForm/>
              </TextBlock>
            </TextImageSection>
            <br></br><br></br>
          <p>Napisz do mnie, podając swoje imię, nazwisko, czego ode mnie potrzebujesz oraz – jeśli dotyczy – planowaną datę ceremonii.</p>
          <p>Godziny kontaktu:</p>
          <ul>
            <li>
              Formularz kontaktowy i wiadomości e-mail: <b>całodobowo </b>
            </li>
            <li>
              Kontakt telefoniczny: <b>667 988 743</b>, od <b>poniedziałku</b> do <b>piątku</b>, w godzinach <b>9:00–17:00</b> 
            </li>
          </ul>
          <p>Znajdziesz mnie także tutaj: </p>
            <center>
              <SocialIcons2>
                <SocialIconLink2 href='https://www.facebook.com/groups/1832360620466564/' target='_blank' aria-label='Facebook'>
                  <FaFacebook />
                </SocialIconLink2>
                <SocialIconLink2 href='https://www.instagram.com/aneta.glowna/' target='_blank' aria-label='Instagram'>
                  <FaInstagram />
                </SocialIconLink2>
                <SocialIconLink2 href='https://youtube.com/@atenida' target='_blank' aria-label='Youtube'>
                  <FaYoutube />
                </SocialIconLink2> 
                <SocialIconLink2 href='https://tiktok.com/@aneta_glowna' target='_blank' aria-label='Tiktok'>
                  <FaTiktok />
                </SocialIconLink2>
              </SocialIcons2>
            </center>
            <hr></hr>

            <h2>Gdzie działam?</h2>
              <p>
Na co dzień pracuję głównie na obszarze Wrocławia i Dolnego Śląska, jednak istnieje możliwość poprowadzenia lub zaprojektowania ceremonii w dowolnym miejscu w Polsce – po wcześniejszym uzgodnieniu dostępności terminu.</p>
<p>Warto napisać do mnie w tej sprawie, ponieważ każde zlecenie traktuję indywidualnie, a logistyczne kwestie (transport i czas) mogą wpływać na ostateczny koszt usługi.</p>

<hr></hr>

            <h2>Czego możesz się spodziewać?</h2>
              <p>Każda ceremonia, którą tworzę, jest dla mnie wyjątkowa – to most między światem widzialnym a tym, który trwa dalej. Tworzę je z serca, z poczucia misji i głębokiego przekonania, że takie rytuały nie służą tylko pojedynczym osobom, ale działają uzdrawiająco także dla całego kolektywu.</p>
<p>W kontakcie ze mną możesz oczekiwać:</p>

<ul>
            <li>
              osobistego, empatycznego podejścia – pełnego uważności i delikatności wobec Twojej sytuacji,
            </li>
            <li>
              profesjonalnego doświadczenia projektowego – dbam o estetykę, symbolikę i rytm ceremonii,
            </li>
            <li>
              współczesnej wiedzy o żałobie i procesie straty – łączę wrażliwość serca z wiedzą psychologiczną i duchową,
            </li>
            <li>
              rytuałów, które naprawdę mają sens i znaczenie, a nie są jedynie powielaniem pustych form.
            </li>
          </ul>
            <br></br><br></br><br></br><br></br><br></br><br></br>
      </InfoWrapper>
    </InfoContainer3>
    <Footer />
    </>
  )
}

export default Kontakt